export const CONFIG = {
  BASE_URL: process.env.REACT_APP_URL || "",
  BASE_URL_GAME: process.env.NEXT_PUBLIC_REACT_APP_GAME_URL || "",
  CONTENT_SERVER_SECRET: process.env.CONTENT_SERVER_SECRET || "",
  DESKTOP_ADS_SLOT_1: process.env.DESKTOP_ADS_SLOT_1 || "0000000000",
  DESKTOP_ADS_SLOT_2: process.env.DESKTOP_ADS_SLOT_2 || "0000000000",
  MOBILE_ADS_SLOT: process.env.MOBILE_ADS_SLOT || "0000000000",
};
